module.exports = __webpack_public_path__ + "img/lamdeini3.0ee4453a.jpg";